import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSettings } from '../lib/useSettings';

export const GoogleAnalytics = () => {
  const location = useLocation();
  const { settings } = useSettings();
  const envMeasurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
  const measurementId = settings?.analytics || envMeasurementId;

  useEffect(() => {
    if (!measurementId) return;

    // Load the GA script on user interaction or delay
    const loadGA = () => {
      if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${measurementId}"]`)) {
        return;
      }
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      document.head.appendChild(script);

      const inlineScript = document.createElement('script');
      inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${measurementId}', { send_page_view: false });
      `;
      document.head.appendChild(inlineScript);
    };

    let interactionTimer = setTimeout(loadGA, 3500);

    const onInteraction = () => {
      loadGA();
      clearTimeout(interactionTimer);
      ['scroll', 'mousemove', 'touchstart', 'keydown'].forEach(event => {
        window.removeEventListener(event, onInteraction, { capture: true });
      });
    };

    ['scroll', 'mousemove', 'touchstart', 'keydown'].forEach(event => {
      window.addEventListener(event, onInteraction, { capture: true, once: true, passive: true });
    });

    return () => {
      clearTimeout(interactionTimer);
      ['scroll', 'mousemove', 'touchstart', 'keydown'].forEach(event => {
        window.removeEventListener(event, onInteraction, { capture: true });
      });
    };
  }, [measurementId]);

  useEffect(() => {
    if (!measurementId) return;
    
    // Ensure gtag is initialized before sending events
    setTimeout(() => {
      if (typeof window !== 'undefined' && (window as any).gtag) {
        (window as any).gtag('event', 'page_view', {
          page_path: location.pathname + location.search,
          page_title: document.title,
        });
      }
    }, 500); // Slight delay to ensure document title is updated by react-helmet
  }, [location, measurementId]);

  return null;
};
